import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import Resizer from "react-image-file-resizer";
import RichEditor from "components/shared/RichEditor";
import fileupload from "../../../../assets/img/icons/fileupload.svg";
import RichTextEditor from "react-rte";
import LabelModal from "components/Menu/Labels/LabelModal";
import { fetchAllLabels } from "store/actions/labelActions";
import TableComponent from "components/shared/Table";
import { addItem } from "store/actions/itemsActions";
import { updateItem } from "store/actions/itemsActions";
import { fetchAllItems } from "store/actions/itemsActions";
import { fetchAddOns } from "store/actions/addOnsAction";


const ItemModal = ({
  isOpen,
  toggle,
  categoryId,
  viewMode,
  editMode,
  activeItem,
  quickItem,
  menuOptions,
  handleMenuSelect,
  selectedMenu,
  categoryOptions,
  loadingCategories,
  selectedCategory,
  setSelectedCategory,
  error,
  menuParamId,
}) => {
  const dispatch = useDispatch();
  const { user, userPermissions } = useSelector((state) => state.auth);
  const { allLabels } = useSelector((state) => state.label);
  const { allItems } = useSelector((state) => state.item);
  const { addOns } = useSelector((state) => state.addOns);

  const fileRef = useRef(null);

  const [data, setData] = useState({
    name: "",
    estimatedTime: "",
    labels: [],
    variants: [],
    images: [],
    recommendedProducts: [],
  });
  const [variant, setVariant] = useState({
    size: "",
    price: "",
    calories: "",
  });
  const [previewImages, setPreviewImages] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);
  const [selectedAddOn, setSelectedAddOn] = useState([]);
  const [editorValue, setEditorValue] = useState(
    RichTextEditor.createEmptyValue()
  );
  const [isLoading, setIsLoading] = useState(false);

  const [labelModal, setLabelModal] = useState(false);
  const [isFetchingLabels, setIsFetchingLabels] = useState(false);
  const [isFetchingProducts, setIsFetchingProducts] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const labelPermissions = userPermissions?.labels;
  const addLabelAccess = user?.type === "restaurant" || labelPermissions?.add;
  const addAccess = user?.type === "restaurant" || userPermissions?.menus?.add;

  const labelModalToggler = () => setLabelModal(!labelModal);

  const handleEstimatedTimeChange = (e) => {
    const { value } = e.target;
    const digitsOnly = value.replace(/\D/g, "");

    if (digitsOnly?.length <= 4) {
      let formattedTime = digitsOnly.slice(0, 2);

      if (digitsOnly?.length > 2) {
        formattedTime += " - " + digitsOnly.slice(2, 4);
      }
      setData({ ...data, estimatedTime: formattedTime });
    }
  };

  const handleImagesChange = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;
    const newImages = [];
    const newPreviewImages = [];
    const validFormats = ["image/jpeg", "image/jpg", "image/png"];
    const maxSizeInKB = 2048;

    for (let i = 0; i < files?.length; i++) {
      const file = files[i];
      const fileType = file.type;

      if (!validFormats.includes(fileType)) {
        toast.error(
          `Error: Invalid file format ${file?.name}. Please select a .jpg, .jpeg, or .png image.`
        );
        continue;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file);
      let height = 0;
      let width = 0;
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          height = this.height;
          width = this.width;
        };
      };
      if (height > 800 || width > 800) {
        toast.warning("Height and Width must not exceed 800px.");
        continue;
      }

      if (file.size > maxSizeInKB * 1024) {
        toast.warn("You can only upload a 2MB picture.");
        continue;
      }

      try {
        const compressedImage = await new Promise((resolve) => {
          Resizer.imageFileResizer(
            file,
            300,
            300,
            "JPEG",
            70,
            0,
            (compressedImage) => {
              resolve(compressedImage);
            },
            "base64"
          );
        });

        const response = await fetch(compressedImage);
        const compressedImageBlob = await response.blob();
        const compressedFile = new File([compressedImageBlob], file.name, {
          type: `image/${file.name.split(".")[1]}`,
          lastModified: file.lastModified,
          lastModifiedDate: file.lastModifiedDate,
        });

        newImages.push(compressedFile);
        newPreviewImages.push(URL.createObjectURL(compressedFile));
      } catch (error) {
        toast.error("Failed to compress the image.");
        return;
      }
    }
    setData({ ...data, images: [...data?.images, ...newImages] });
    setPreviewImages([...previewImages, ...newPreviewImages]);
    e.target.value = null;
  };

  const handleDrop = async (droppedFiles) => {
    const newImages = [];
    const newPreviewImages = [];

    const maxSizeInKB = 2048;
    const validFormats = ["image/jpeg", "image/jpg", "image/png"];

    for (let i = 0; i < droppedFiles?.length; i++) {
      const file = droppedFiles[i];
      const fileType = file.type;

      if (!validFormats.includes(fileType)) {
        toast.error(
          `Error: Invalid file format ${file?.name}. Please select a .jpg, .jpeg, or .png image.`
        );

        continue;
      }

      if (file.size > maxSizeInKB * 1024) {
        toast.warn("You can only upload a 2MB picture.");

        continue;
      } else {
        try {
          const compressedImage = await new Promise((resolve) => {
            Resizer.imageFileResizer(
              file,
              300,
              300,
              "JPEG",
              70,
              0,
              (compressedImage) => {
                resolve(compressedImage);
              },
              "base64"
            );
          });

          const response = await fetch(compressedImage);
          const compressedImageBlob = await response.blob();
          const compressedFile = new File([compressedImageBlob], file.name, {
            type: `image/${file.name.split(".")[1]}`,
            lastModified: file.lastModified,
            lastModifiedDate: file.lastModifiedDate,
          });

          newImages.push(compressedFile);
          newPreviewImages.push(URL.createObjectURL(compressedFile));
        } catch (error) {
          toast.error("Failed to compress the image.");
          return;
        }
      }
    }

    setData({ ...data, images: [...data?.images, ...newImages] });
    setPreviewImages([...previewImages, ...newPreviewImages]);
  };

  const handleRemoveImage = (removedImage, imageIndex) => {
    setPreviewImages((prevPreviewImages) =>
      prevPreviewImages.filter((image) => image !== removedImage)
    );
    setData({
      ...data,
      images: data?.images?.filter((_, index) => index !== imageIndex),
    });
    if (!removedImage.includes("blob")) {
      setRemovedImages([...removedImages, removedImage]);
    }
  };

  const handleAddVariant = (e) => {
    e.preventDefault();

    if (editIndex !== null) {
      const updatedVariants = [...data.variants];
      updatedVariants[editIndex] = variant;
      setData({ ...data, variants: updatedVariants });
      setEditIndex(null);
    } else {
      setData({
        ...data,
        variants: [variant, ...data.variants],
      });
    }

    resetForm();
  };

  const handleVariantChange = (e) => {
    const { name, value } = e.target;

    if (!isNaN(value) && Number(value) > 10000) {
      toast.warning("Price cannot exceed 10,000");
      return;
    }

    const formattedValue = name === "size" ? value.trim() : value;

    setVariant({
      ...variant,
      [name]: formattedValue,
    });
  };

  const handleEditVariant = (index) => {
    setVariant(data.variants[index]);
    setEditIndex(index);
  };

  const handleDeleteVariant = (index) => {
    const updatedVariants = data.variants.filter((_, i) => i !== index);
    setData({ ...data, variants: updatedVariants });
  };

  const handleCancelEdit = () => {
    resetForm();
  };

  const resetForm = () => {
    setVariant({ size: "", price: "", calories: "" });
    setEditIndex(null);
  };

  const validateItemData = () => {
    if (
      !data?.name ||
      !data?.estimatedTime ||
      !data?.variants?.length ||
      !data?.images?.length
    ) {
      return false;
    }
    return true;
  };

  const handleAddItem = () => {
    if (!addAccess) {
      toast.error("You don't have access to perform this action");
      return;
    }
    if (!validateItemData()) {
      toast.error("Please fill all required fields");
      return;
    }
    if (quickItem && !selectedCategory) {
      toast.error("Please select a category");
      return;
    }
    setIsLoading(true);
    const payload = {
      ...data,
      menuID: quickItem ? selectedMenu.value : menuParamId,
      comments: editorValue.toString("html"),
      restaurantID: user?.restaurantID,
      addOns: selectedAddOn,
    };

    dispatch(
      addItem({
        categoryId: quickItem ? selectedCategory.value : categoryId,
        payload,
      })
    )
      .then(() => {
        toast.success("Item Added Successfully");
        toggle();
      })
      .finally(() => setIsLoading(false));
  };

  const handleEditItem = () => {
    if (!addAccess) {
      toast.error("You don't have access to perform this action");
      return;
    }
    if (!validateItemData()) {
      toast.error("Please fill all required fields");
      return;
    }
    setIsLoading(true);
    const payload = {
      ...data,
      comments: editorValue.toString("html"),
      restaurantID: user?.restaurantID,
      addOns: selectedAddOn || [],
    };
    dispatch(
      updateItem({
        itemId: activeItem?.id,
        categoryId,
        payload,
        removedImages,
      })
    )
      .then(() => toggle())
      .finally(() => setIsLoading(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (viewMode) {
      toggle();
      return;
    }
    if (editMode) {
      handleEditItem();
    } else {
      handleAddItem();
    }
  };

  useEffect(() => {
    setIsFetchingLabels(true);
    dispatch(fetchAllLabels(user?.restaurantID || "")).finally(() =>
      setIsFetchingLabels(false)
    );
  }, [dispatch, user?.restaurantID]);

  useEffect(() => {
    if (user?.restaurantID) {
      setIsFetchingProducts(true);
      dispatch(fetchAllItems(user?.restaurantID)).finally(() =>
        setIsFetchingProducts(false)
      );
    }
  }, [dispatch, user]);

  useEffect(() => {
    dispatch(fetchAddOns(user.restaurantID));
  }, [dispatch, user.restaurantID]);

  useEffect(() => {
    if (isOpen) {
      if ((editMode || viewMode) && activeItem) {
        setData({
          name: activeItem?.name || "",
          estimatedTime: activeItem?.estimatedTime || "",
          labels: activeItem?.labels || [],
          variants: activeItem?.variants || [],
          images: activeItem?.images || [],
          recommendedProducts: activeItem?.recommendedProducts || [],
        });
        setSelectedAddOn(activeItem?.addOns || []);
        setPreviewImages(activeItem?.images || []);
        setEditorValue(
          activeItem?.comments
            ? RichTextEditor.createValueFromString(activeItem.comments, "html")
            : RichTextEditor.createEmptyValue()
        );
      }
    } else {
      setData({
        name: "",
        estimatedTime: "",
        labels: [],
        variants: [],
        images: [],
        recommendedProducts: [],
      });
      setSelectedAddOn([]);
      setPreviewImages([]);
      setEditorValue(RichTextEditor.createEmptyValue());
    }
  }, [isOpen, editMode, viewMode, activeItem]);

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader
          toggle={toggle}
          className="align-items-center border-bottom"
        >
          {viewMode ? "View" : editMode ? "Edit" : "Add"} Item
        </ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            {quickItem && (
              <>
                <FormGroup>
                  <Label>Menu</Label>
                  <Select
                    options={menuOptions}
                    isDisabled={viewMode}
                    value={selectedMenu}
                    onChange={handleMenuSelect}
                    placeholder="Select a menu..."
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Category</Label>
                  <Select
                    options={categoryOptions}
                    isDisabled={
                      loadingCategories ||
                      viewMode ||
                      categoryOptions?.length === 0
                    }
                    isLoading={loadingCategories}
                    value={selectedCategory}
                    onChange={(opt) => setSelectedCategory(opt)}
                    placeholder={
                      !selectedMenu
                        ? "Select a menu first"
                        : loadingCategories
                        ? "Loading categories..."
                        : "Select a category..."
                    }
                  />
                  {categoryOptions?.length === 0 && error && (
                    <div className="text-danger mt-2">
                      <p style={{ fontSize: "12px" }}>
                        No categories available for this menu, Please add a
                        category first to add items.
                      </p>
                    </div>
                  )}
                </FormGroup>
              </>
            )}
            <FormGroup>
              <Label for="name">Item Name</Label>
              <Input
                type="text"
                name="name"
                id="name"
                required
                placeholder="Item Name"
                value={data?.name}
                onChange={(e) => setData({ ...data, name: e.target.value })}
                disabled={viewMode}
              />
            </FormGroup>
            <FormGroup>
              <Label for="item-name">Est. Prep Time(mins)</Label>
              <Input
                type="text"
                placeholder="00 - 00"
                required
                value={data?.estimatedTime}
                onChange={handleEstimatedTimeChange}
                disabled={viewMode}
              />
            </FormGroup>
            <Label for="price">Comments</Label>
            <FormGroup>
              <RichEditor
                value={editorValue}
                onChange={(val) => setEditorValue(val)}
                viewMode={viewMode}
              />
            </FormGroup>
            <FormGroup>
              <div className="d-flex justify-content-between align-items-end mb-2">
                <Label for="label" className="mb-0">
                  Label
                </Label>
                {!viewMode && addLabelAccess && (
                  <Button size="sm" color="primary" onClick={labelModalToggler}>
                    Add Label
                  </Button>
                )}
              </div>
              <Select
                id="label"
                name="label"
                defaultValue={null}
                placeholder="Select Label"
                isSearchable={true}
                isLoading={isFetchingLabels}
                isDisabled={isFetchingLabels || viewMode}
                isMulti
                value={data?.labels}
                onChange={(selected) =>
                  setData({ ...data, labels: [...selected] })
                }
                options={allLabels?.map((item) => ({
                  id: item?.id,
                  value: item?.labelName,
                  label: item?.labelName,
                }))}
              />
            </FormGroup>
            <FormGroup>
              <div className="d-flex justify-content-between align-items-end mb-2">
                <Label for="label" className="mb-0">
                  Add Ons
                </Label>
              </div>
              <Select
                id="addOns"
                name="addOns"
                placeholder="Select Add Ons"
                isSearchable
                isMulti
                isDisabled={isFetchingLabels || viewMode}
                options={(addOns || []).map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
                value={(selectedAddOn || []).map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
                onChange={(selected) =>
                  setSelectedAddOn(
                    selected?.map((item) => {
                      const matchedAddOn = addOns.find(
                        (add) => add.id === item.value
                      );
                      return {
                        id: matchedAddOn?.id,
                        name: matchedAddOn?.name,
                      };
                    }) || []
                  )
                }
              />
            </FormGroup>

            <Label for="label">Images</Label>
            <Row>
              {previewImages?.map((url, index) => (
                <Col xs={6} sm={4} key={index}>
                  <div className="d-flex flex-column align-items-center w-100 justify-content-between border mt-1">
                    <img
                      src={url}
                      alt="item-img"
                      className="p-1 w-100 h-100"
                      style={{
                        objectFit: "cover",
                        minHeight: "100px",
                        maxHeight: "100px",
                      }}
                    />
                    {!viewMode && (
                      <i
                        className="fas fa-trash-alt p-2 border w-100 d-flex justify-content-center cursor-pointer shadow-sm"
                        onClick={() => handleRemoveImage(url, index)}
                      />
                    )}
                  </div>
                </Col>
              ))}
              {!viewMode && (
                <Col
                  sm={12}
                  onDrop={(e) => {
                    e.preventDefault();
                    handleDrop(e.dataTransfer.files);
                  }}
                >
                  <FormGroup className="file-input mt-2">
                    <input
                      ref={fileRef}
                      type="file"
                      multiple
                      name="item"
                      id="file-images"
                      placeholder="Images"
                      className="file-input__input"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleImagesChange}
                    />
                    <Label
                      for="file-images"
                      className={`d-flex flex-column file-input__label ${
                        previewImages && previewImages?.length > 0
                          ? "d-none"
                          : ""
                      }`}
                    >
                      <img src={fileupload} alt="" className="mb-2" />
                      <span className="text-center">Upload Images</span>
                    </Label>
                  </FormGroup>
                </Col>
              )}
            </Row>

            <Label for="price" className={`${viewMode && "mt-3"}`}>
              Variants
            </Label>
            {!viewMode && (
              <Row className="d-flex justify-content-center align-items-end mb-3">
                <Col sm={3}>
                  <FormGroup className="mb-0">
                    <Label for="size" tag="h5">
                      Size
                    </Label>
                    <Input
                      id="size"
                      type="text"
                      name="size"
                      value={variant.size}
                      placeholder="Size"
                      onChange={handleVariantChange}
                    />
                  </FormGroup>
                </Col>
                <Col sm={3}>
                  <FormGroup className="mb-0">
                    <Label for="price" tag="h5">
                      Price
                    </Label>
                    <Input
                      id="price"
                      name="price"
                      type="number"
                      step="any"
                      min={0}
                      placeholder="Price"
                      value={variant.price}
                      onChange={handleVariantChange}
                    />
                  </FormGroup>
                </Col>
                <Col sm={3}>
                  <FormGroup className="mb-0">
                    <Label for="calories" tag="h5">
                      Calories
                    </Label>
                    <Input
                      id="calories"
                      name="calories"
                      type="number"
                      min={1}
                      placeholder="Calories"
                      value={variant.calories}
                      onChange={handleVariantChange}
                    />
                  </FormGroup>
                </Col>
                <Col
                  sm={3}
                  className={`d-flex ${editIndex !== null && "p-0 pr-3"}`}
                >
                  {editIndex !== null && (
                    <Button
                      color="danger"
                      className="mt-3 px-0"
                      style={{ width: "50px" }}
                      onClick={handleCancelEdit}
                    >
                      <i className="fa fa-times" />
                    </Button>
                  )}
                  <Button
                    block
                    color="success"
                    className="mt-3 px-0"
                    style={{ width: editIndex !== null ? "50px" : "100%" }}
                    disabled={!variant.size || !variant.price}
                    onClick={handleAddVariant}
                  >
                    {editIndex !== null ? <i className="fa fa-check" /> : "Add"}
                  </Button>
                </Col>
              </Row>
            )}
            {data?.variants?.length > 0 && (
              <TableComponent
                className="align-items-center table-flush"
                responsive
              >
                <thead className="thead-light border">
                  <tr>
                    <th scope="col">Size</th>
                    <th scope="col">Price</th>
                    <th scope="col">Calories</th>
                    {!viewMode && <th scope="col">Actions</th>}
                  </tr>
                </thead>
                <tbody className="border">
                  {data.variants.map((variant, index) => (
                    <tr key={index}>
                      <td className="text-capitalize">{variant.size}</td>
                      <td>{variant.price}</td>
                      <td>{variant.calories}</td>
                      {!viewMode && (
                        <td className="table-actions">
                          <Button
                            size="sm"
                            color="warning"
                            onClick={() => handleEditVariant(index)}
                            disabled={viewMode}
                          >
                            <i className="fa fa-edit" />
                          </Button>
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => handleDeleteVariant(index)}
                            disabled={viewMode}
                          >
                            <i className="fa fa-trash" />
                          </Button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </TableComponent>
            )}

            <FormGroup className={`${!viewMode && "mt-4"}`}>
              <Label for="recommendedProducts">Recommended Products</Label>
              <Select
                id="recommendedProducts"
                name="recommendedProducts"
                defaultValue={null}
                placeholder="Add recommended products"
                isSearchable={true}
                isLoading={isFetchingProducts}
                isDisabled={isFetchingProducts || viewMode}
                isMulti
                value={data?.recommendedProducts}
                onChange={(selected) =>
                  setData({ ...data, recommendedProducts: [...selected] })
                }
                options={allItems
                  ?.filter(
                    (item) =>
                      !activeItem || (activeItem && item?.id !== activeItem?.id)
                  )
                  ?.map((item) => ({
                    id: item?.id,
                    value: item?.name,
                    label: item?.name,
                  }))}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter className="border-top py-3">
            <Button
              type="submit"
              color="primary"
              className="d-flex align-items-center"
              disabled={isLoading || !validateItemData()}
            >
              {isLoading && <Spinner size="sm" className="mr-2" />}
              {!viewMode ? "Save" : "Close"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      <LabelModal isOpen={labelModal} toggle={labelModalToggler} />
    </>
  );
};

export default ItemModal;
